<template>
  <div class="pb-90">
    <div v-if="hasRemovedItems" class="notificationFixLine">
      <div class="wrapper">
        <div class="d-flex">
          <div class="text-wrap">
            <p class="fs-14">
              {{ removedItemTitle }}
              <button class="btn btn-link" @click.prevent="restoreItem">
                {{ translates['undo'] }}
              </button>
            </p>
          </div>
          <button class="close" type="button" @click="closeRestoreNotification">x</button>
        </div>
      </div>
    </div>

    <div v-if="showEmptyBag" class="emptyBag">
      <div class="wrapper">
        <div class="d-flex">
          <p class="fs-24 bold color-black">
            {{ translates['empty_bag'] }}
          </p>
          <img alt="Empty Bag" src="/assets/images/builds/empty-bag.svg">
          <a class="btn btn-green" href="/en/home">
            {{ translates['back_to_home'] }}
          </a>
        </div>
      </div>
    </div>

    <div v-if="showBag" class="yourBag">
      <div class="wrapper">
        <div class="titleYb grid">
          <div class="col x-5">
            <a class="backBtn" href="/en/choose">
              <svg
                fill="none"
                height="12"
                viewBox="0 0 8 12"
                width="8"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.999999 11.4531L6 6.45313L1 1.45312"
                  stroke="black"
                  stroke-width="1.5"
                />
              </svg>
              {{ translates.back }}
            </a>
          </div>
          <div class="col x-7">
            <p class="fs-36 color-black bold m-0">
              {{ translates['your_bag'] }}
            </p>
          </div>
        </div>
        <div
          v-for="(item, index) in items"
          :key="item.id"
          class="grid">
          <basket-item :index="index" :item="item" :pedals-list="pedalsList" :trans="translates"/>
        </div>
        <delivery-parameters :model="lastItemModel" :trans="translates"/>
      </div>
    </div>

    <carousel-accessories-vue :accessories="accessories" :trans="translates"/>

    <div v-if="showBag" class="resultFixLine">
      <div class="wrapper">
        <div class="grid">
          <div class="col x-5">
            <div class="text-wrap">
              <img alt="" src="/assets/images/builds/clock-ic.svg"/>
              <p class="fs-14">
                <strong>{{ translates['delivery_date'] }}</strong> {{ deliveryDate }}
              </p>
            </div>
            <div class="text-wrap">
              <img alt="" src="/assets/images/builds/rocket-ic.svg"/>
              <p class="fs-14">
                <strong>{{ translates['free_shipping'] }}</strong> Europe*
              </p>
            </div>
          </div>
          <div class="col x-7">
            <div class="totalText">
              <p class="fs-20">{{ translates['total'] }}: <span>{{ total }}</span></p>
              <p class="fs-10">
                {{ translates['amount_for_non_eu'] }}
              </p>
            </div>
            <a class="btn btn-green" @click.prevent="goToCheckout">
              {{ translates['to_checkout'] }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showPedalModal" class="modalPrimary">
      <div class="wrap">
        <div class="modalPrimary-h">
          <p class="modalPrimary__title">
            {{ translates['choose_pedals'] }}
          </p>
          <button class="close" type="button" @click="hidePedalModal">x</button>
        </div>
        <div class="modalPrimary-c">
          <div class="grid">
            <div class="chooseBox">
              <div
                v-for="pedal in filteredPedals"
                :key="pedal.id"
                :class="{active: isSelected(pedal)}"
                class="item"
                @click="addPedal(pedal)"
              >
                <div class="img-wrap">
                  <img
                    :alt="pedal['web_bike_title']"
                    :src="pedal['media_content'].preview"
                  />
                </div>
                <div class="text-wrap">
                  <p class="text">{{ pedal['web_bike_title'] }}</p>
                  <p class="price">
                    {{ $crConverter(pedal['prices']['price_for_eu'] / 100, 'EUR') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modalPrimary-f">
        <div class="wrap">
          <div class="d-flex">
            <p class="fs-17 bold color-black">
              <span>{{ translates['total_pedal_cost'] }}:</span> {{ selectedPedalCost }}
            </p>
            <button
              :class="{disabled: this.selectedPedals.length === 0}"
              :disabled="this.selectedPedals.length === 0"
              class="btn btn-green"
              type="button"
              @click="addPedalToSelectedItem"
            >
              {{ translates['add_selected_pedal'] }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="false" class="modalPrimary">
      <div class="modalBox">
        <button class="close" @click="cartShowMore">x</button>
        <p class="fs-36">The accessories box includes:</p>

        <ul class="modalBox__list">
          <li>Forestal Alpha Box Carbon Enduro 29" TR 170</li>
          <li>{{ translates['Ringing bell'] }}</li>
          <li>{{ translates['Front light'] }}</li>
          <li>{{ translates['Rear light'] }}</li>
          <li>{{ translates['Reflectors kit'] }}</li>
        </ul>

        <button class="btn btn-green w-100" type="button">
          {{ translates['understand'] }}
        </button>
      </div>
    </div>

    <div class="modalPrimary modal-sm custom-primary-modal" :class="{active: emailNotActivated}">
      <div class="modalBox text-center">
        <p class="text-lg">
          <span>
            Dear Customer, Please activate your email before start checkout.
          </span>
        </p>

        <div class="btn-modal-group">
          <button type="button" class="btn btn-green btn-sm w-100" @click.prevent="hideActivateEmailInfoModal">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import AccessoriesCarousel from "./parts/AccessoriesCarousel";
import BuildCarouselSync from "../builds/parts/BuildCarouselSync";
import DeliveryParameters from "../builds/parts/DeliveryParameters";
import Item from "./parts/Item";
import {mapGetters} from "vuex";

export default {
  name: "Basket",
  props: ['pedalsList', 'accessories', 'trans'],
  components: {
    BuildCarouselSync,
    'carousel-accessories-vue': AccessoriesCarousel,
    'basket-item': Item,
    vSelect,
    'delivery-parameters': DeliveryParameters,
  },
  computed: {
    ...mapGetters({
      showPedalModal: 'baskets/showPedalModal',
      selectedItem: 'baskets/selectedBasketItem',
      isAuth: "isAuth",
      getAuthUser: "getAuthUser"
    }),
    translates() {
      return this.trans.text.basket
    },
    lastItem() {
      const months = {
        'January': 1,
        'February': 2,
        'March': 3,
        'April': 4,
        'May': 5,
        'June': 6,
        'July': 7,
        'August': 8,
        'September': 9,
        'October': 10,
        'November': 11,
        'December': 12,
      };
      let maxItem = null
      for (let item of this.items) {
        if (item.build && item.build.model && item.build.model['delivery_info'] || (item.build && item.build['delivery_date_parsed'])) {
          let month
          let year
          if (item.build['delivery_date_parsed']) {
            month = item.build['delivery_date_parsed']['month']
            year = item.build['delivery_date_parsed']['year']
          } else {
            let deliveryInfo = item.build.model['delivery_info'].split(' ')
            month = deliveryInfo[0]
            year = deliveryInfo[1]
          }
          if (maxItem === null) {
            maxItem = {
              month: month,
              year: year,
              model: item.build.model,
              delivery_date: item.build['delivery_date_parsed'] || null
            }
          } else if (year > maxItem.year) {
            maxItem = {
              month: month,
              year: year,
              model: item.build.model,
              delivery_date: item.build['delivery_date_parsed'] || null
            }
          } else if (year === maxItem.year) {
            let maxItemMonthKey = months[maxItem.month]
            let currentMonthKey = months[month]
            if (currentMonthKey > maxItemMonthKey) {
              maxItem = {
                month: month,
                year: year,
                model: item.build.model,
                delivery_date: item.build['delivery_date_parsed'] || null
              }
            }
          }
        }
      }
      if (maxItem !== null) {
        return maxItem
      }
      return null
    },
    lastItemModel() {
      if (this.lastItem) {
        return this.lastItem
      }

      return null
    },
    deliveryDate() {
      const defaultDate = this.$moment().add(3, 'month').format('MMMM YYYY')

      if (this.lastItem) {
        if (this.lastItem['delivery_date']) {
          return this.months[this.lastItem['delivery_date']['month']] + ' ' + this.lastItem['delivery_date']['year']
        }
        return this.lastItem.model['delivery_info'] || defaultDate
      }

      return defaultDate
    },
    filteredPedals() {
      return this.pedalsList.filter(item => {
        let models = item.models
        return models.length === 0 || models.find(model => {
          return model.id === this.selectedItem.build.model.id
        }) !== undefined;
      })
    },
    selectedPedalCost() {
      let total = 0
      for (let pedal of this.selectedPedals) {
        total += pedal['prices']['price_for_eu']
      }

      return this.$crConverter(total / 100, 'EUR')
    },
    pedalMinPrice() {
      let min = null
      this.pedalsList.map(pedal => {
        if (min === null || pedal['prices']['price_for_eu'] < min) {
          min = pedal['prices']['price_for_eu']
        }
        return pedal
      })
      return min
    },
    addPedalText() {
      return this.translates['add_other_pedals']
    },
    showBag() {
      return this.$store.state.baskets.basket
        && this.$store.state.baskets.basket.items.length > 0
        && this.loading === false
    },
    showEmptyBag() {
      return (!this.$store.state.baskets.basket
          || this.$store.state.baskets.basket.items.length === 0)
        && this.loading === false
    },
    hasRemovedItems() {
      return this.$store.state.baskets.removedItem
    },
    removedItemTitle() {
      return this.$store.state.baskets.removedItemTitle
    },
    items() {
      return this.$store.state.baskets.basket.items
    },
    total() {
      let total = 0
      this.items.map(item => {
        total += this.itemSubTotal(item, false)
      })

      return this.$crConverter(total / 100, 'EUR')
    }
  },
  data() {
    return {
      emailNotActivated: false,
      selectedPedals: [],
      loading: true,
      notiFl: true,
      chooseProduct: false,
      isCsm: false,
      isShown: false,
      isOpen: false,
      selected: 1,
      mainBagOptions: {},
      navBagOptions: {
        asNavFor: '.carousel-main',
        contain: true,
        pageDots: false,
      },
      months: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
      },
      lang: 'en'
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  mounted() {
    this.lang = this.getMeta('selected-language') || 'en';
    this.loadBasket();
    if (localStorage.getItem('removedItem')) {
      this.$store.commit('baskets/setRemovedItem', {
        id: localStorage.getItem('removedItem'),
        title: localStorage.getItem('removedItemText'),
      })
    }
  },
  methods: {
    hideActivateEmailInfoModal() {
      this.emailNotActivated = false

      let a = document.createElement('a')
      a.href = "/en/profile"
      a.target = "_blank"

      a.click()

      setTimeout(() => {
        a.remove()
      }, 20)
    },
    getMeta(metaName) {
      const metas = document.getElementsByTagName('meta');

      for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === metaName) {
          return metas[i].getAttribute('content');
        }
      }

      return null;
    },
    beforeWindowUnload() {
      localStorage.removeItem('removedItem')
    },
    checkActivated() {
      return new Promise((resolve) => {
        this.$store.dispatch('checkout/checkActivated').then(response => {
          resolve(response.data.data.status)
        }).catch(err => {
          console.log("Error checking user activating", err)
          resolve(false)
        })
      })
    },
    goToCheckout() {
      if (!this.isAuth) {
        localStorage.setItem('isRunCheckout', "true");
      }

      if (this.isAuth) {
        if (this.getAuthUser.email_verified_at) {
          location.href = `/en/checkout?redirect=true`
        } else {
          this.emailNotActivated = true
        }
      } else {
        location.href = `/${this.lang}/login`
      }
    },
    extraImage(extra) {
      if (extra.media) {
        return extra.media.preview
      }

      return extra['media_content'].preview
    },
    addPedalToSelectedItem() {
      this.$store.dispatch('baskets/addExtraToItem', {
        path: this.$path,
        item: this.selectedItem.id,
        extra: this.selectedPedals
      }).then(() => {
        this.selectedPedals = []
        document.getElementsByTagName('body')[0].classList.remove('vh100')
      })
    },
    showMoreBtn(item) {
      return item.build.specs.length > 9
    },
    addPedal(pedal) {
      let existInSelected = this.selectedPedals.find(item => {
        return item.id === pedal.id
      }) !== undefined;
      let existInItem = this.selectedItem.extra.find(item => {
        return item.id === pedal.id
      }) !== undefined
      if (!existInSelected && !existInItem) {
        this.selectedPedals.push(pedal)
      } else {
        this.selectedPedals = this.selectedPedals.filter(item => {
          return item.id !== pedal.id
        })
      }
    },
    isSelected(pedal) {
      return this.selectedPedals.find(item => {
          return item.id === pedal.id
        }) !== undefined
        || this.selectedItem.extra.find(item => {
          return item.id === pedal.id
        }) !== undefined
    },
    hidePedalModal() {
      this.$store.commit('baskets/hidePedalModal')
      document.getElementsByTagName('body')[0].classList.remove('vh100')
    },
    pedals(item) {
      return item.extra.filter(item => {
        if (item['build_category']) {
          return item['build_category'].title === 'Pedals'
        } else {
          return item['sub_category'].title === 'Pedals'
        }
      })
    },
    hasPedals(item) {
      return this.pedals(item).length > 0
    },
    purchaseType(item) {
      if (item.purchase_type === 'reservation') {
        return this.translates['reservation_price'];
      } else if (item.purchase_type === 'full') {
        return this.translates['full_price'];
      }
      return null;
    },
    qtyOptions(item) {
      let from
      let range
      if (item.build.stock < 10 && item.purchase_type !== 'reservation') {
        from = Array(item.build.stock + 1).keys();
      } else {
        from = Array(11).keys();
      }
      range = Array.from(from)
      range.shift()
      return range
    },
    itemSubTotal(item, convert = true) {
      let total
      let euCountry = item.build.country_taxes.find(country => {
        return country.vat === 21
      })
      if (item.purchase_type === 'full') {
        if (item['pre_sale_price']) {
          total = euCountry.ex_price * item.qty;
        } else {
          total = euCountry.price * item.qty;
        }
      } else {
        total = euCountry.res_price * item.qty;
      }
      item.extra.map(extra => {
        total += extra['prices']['price_tax_base'] * extra.qty
      })
      if (convert) {
        return this.$crConverter(total / 100, 'EUR')
      }

      return total
    },
    changeQuantity(qty, item, index) {
      let oldValue = item.qty
      this.$store.dispatch('baskets/changeBasketItemQTY', {
        path: this.$path,
        qty: qty,
        item: item.id,
      }).then(() => {

      }).catch(() => {
        this.$store.commit('baskets/changeLocalItemQTY', {
          index: index,
          qty: oldValue
        })
      })
    },
    restoreItem() {
      this.$store.dispatch('baskets/restore', {
        path: this.$path,
        item: this.$store.state.baskets.removedItem,
      }).then(result => {
        this.$store.dispatch('baskets/count', {path: this.$path})
        this.$store.commit('baskets/appendToBasket', result.item)
        this.$store.commit('baskets/setRemovedItem', {
          id: null,
          title: null
        })
        localStorage.removeItem('removedItem')
        localStorage.removeItem('removedItemText')
      })
        .catch()
    },
    removeItem(item) {
      this.$store.dispatch('baskets/removeItem', {
        path: this.$path,
        item: item.id,
      }).then(() => {
        this.$store.commit('baskets/setRemovedItem', {
          id: item.id,
          title: this.buildTitle(item.build)
        })
        this.$store.commit('baskets/hideItem', item)
        localStorage.setItem('removedItem', item.id)
        localStorage.setItem('removedItemText', this.buildTitle(item.build))
      }).catch()
    },
    getIncludedInDelivery(item) {
      return item.build['included_in_delivery']
    },
    getSpecs(item) {
      if (item.showFullSpecs) {
        return item.build.specs
      }

      return item.build.short_specs
    },
    buildTitle(build) {
      return build['web_bike_title'] + ' - ' + build.size['web_title']
    },
    loadBasket() {
      this.$store.dispatch('baskets/loadBasket', {
        path: this.$path
      }).finally(() => {
        this.loading = false
      })
    },
    learnMore() {
      this.isShown = !this.isShown
    },
    openList(index) {
      this.$store.commit('baskets/toggleShowingFullSpecForOption', index);
    },
    cartShowMore() {
      this.isCsm = !this.isCsm
    },
    closeRestoreNotification() {
      this.$store.commit('baskets/setRemovedItem', {
        id: null,
        title: null
      })
      localStorage.removeItem('removedItem')
      localStorage.removeItem('removedItemText')
    },
    addBodyPadding() {
      let infoFooter = document.getElementsByClassName('resultFixLine')[0]
      document.getElementsByTagName("body")[0].style.paddingBottom = infoFooter.getBoundingClientRect().height + 'px'
    }
  },
  watch: {
    loading(loaded) {
      if (!loaded) {
        setTimeout(() => {
          this.addBodyPadding()
        }, 1)

      }
    }
  }
}
</script>

<style lang="scss">
.yourBag {
  padding-top: 48px;

  .w-100 {
    width: 100%;
  }

  .titleYb {
    &.grid {
      margin-bottom: 64px;
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .grid {
    display: grid;
    grid-gap: 64px;
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    padding-bottom: 90px;
    margin-bottom: 90px;
    border-bottom: 1px solid #e3e3e3;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }

    .col {
      &.x-5 {
        grid-column: span 5;
      }

      &.x-7 {
        grid-column: span 7;
      }
    }
  }

  .sticky-wrap {
    position: sticky;
    top: 120px;
  }

  .d-flex {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    position: relative;
  }

  .abs-wrap {
    //position: absolute;
    top: 0;
    right: 0;
    //display: flex;
    //justify-content: space-between;
    //align-items: center;
    //flex-wrap: wrap;
    text-align: right;
    //padding-left: 16px;
    max-width: calc(46% - 118px);

    .btn-link {
      margin-top: 20px;
      margin-left: auto;
    }

    .select-primary .vs__dropdown-toggle {
      display: flex;
    }

    .vs__selected-options {
      display: flex;
      flex-basis: 100%;
      flex-grow: 1;
      flex-wrap: wrap;
      padding: 0 2px;
      position: relative;
    }

    .select-primary .vs__dropdown-menu {
      padding: 0;
      box-shadow: none;
      border-color: #f8f8f8;
      border-radius: 7px;
      top: 0;
      max-height: 391px;
    }

    .select-primary .vs__dropdown-menu {
      display: block;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      z-index: 1000;
      margin: 0;
      width: 100%;

      overflow-y: auto;
      border: 1px solid rgba(60, 60, 60, .26);
      border-top-style: none;
      text-align: left;
      list-style: none;
      background: #fff;
      padding: 0;
      box-shadow: none;
      border-color: #f8f8f8;
      border-radius: 7px;
      top: 0;
      max-height: 391px;
    }
  }

  .yourBag__name {
    font-weight: bold;
    font-size: 24px;
    line-height: 34px;
    color: #000000;
    margin: 0 0 16px;
    //width: 346px;
    max-width: 54%;
  }

  .select-primary-wrap {
    margin: 0 auto;
    position: relative;

    .buyMore {
      position: absolute;
      background: #fff;
      z-index: 5;
      width: 200px;
      padding: 15px 22px;
      border-radius: 6px;
      border: 1px solid #e3e3e3;
      font-size: 14px;
      line-height: 19px;
      color: #000;
      margin: auto;
      right: 0;
      top: auto;
      left: 0;
      bottom: calc(100% + 2px);

      a {
        text-decoration: none;
        font-weight: 700;
        color: #000;
      }
    }
  }

  .select-primary {
    width: 70px;
    margin: 0 auto;
    height: 39px;

    .vs__dropdown-toggle {
      display: flex;
    }

    .vs__selected-options {
      padding: 0;
      width: calc(100% - 8px);
      text-align: center;
      padding-right: 8px;
    }

    .vs__dropdown-menu,
    ul {
      width: 70px;
      max-width: 70px;
      min-width: 70px;
      text-align: center;

      li {
        cursor: pointer;
      }
    }

    &.vs--open {
      .vs__dropdown-menu {
        position: absolute;
        z-index: 1;
        background: #fff;
        top: 0px;
        border-radius: 7px;
      }
    }
  }

  .yourBag__price {
    font-weight: bold;
    font-size: 24px;
    line-height: 25px;
    color: #000000;
    margin: 0;
    //width: calc(100% - 70px);
    padding-left: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    span {
      font-size: 12px;
      line-height: 12px;
      color: rgba(0, 0, 0, 0.3);
      display: block;
      margin-top: 2px;
    }
  }

  .yourBag__text {
    font-weight: normal;
    font-size: 14px;
    line-height: 26px;
    width: 54%;
    margin: 0 0 24px;
  }

  .yourBag__list {
    margin: 0 0 28px;
    padding: 0;
    list-style: none;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    li {
      font-size: 14px;
      line-height: 1.4;
      color: #474747;
      margin-bottom: 12px;
      display: none;

      &:last-child {
        margin-bottom: 0;
      }

      strong {
        font-weight: 500;
      }

      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8),
      &:nth-child(9) {
        display: block;
      }
    }

    &.open {
      li {
        display: block;
      }

      & ~ .btn {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  .btn.btn-link {
    display: flex;
    align-items: center;
  }

  hr {
    background-color: #e3e3e3;
    height: 1px;
    border: none;
    margin: 40px 0;
    width: 100%;
  }

  .includedDelivery {
    width: 100%;

    .fs-20 {
      margin: 0 0 24px;
      font-weight: 500;
      line-height: 1.1;
      color: #000;
    }

    .flex-wrapper {
      display: grid;

      grid-gap: 20px 40px;
      width: 100%;
      grid-template-columns: repeat(2, 1fr);

      .item {
        display: flex;
        align-items: center;

        .img-wrap {
          width: 96px;
          height: 96px;
          position: relative;
          background: #f8f8f8;
          border-radius: 7px;

          img {
            //width: 62px;
            //height: 60px;
            width: 70%;
            height: 70%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            object-fit: contain;
            //mix-blend-mode: darken;
          }
        }

        .text {
          padding-left: 16px;
          width: calc(100% - 96px);
          color: #474747;
          font-size: 14px;
          line-height: 20px;

          .btn-link {
            font-weight: 500;
            margin-top: 8px;

            .arr {
              margin: 0 0 0 10px;
              transform: rotate(-90deg);
            }

            .download {
              margin: 0 0 0 10px;
            }
          }
        }
      }
    }
  }

  .additionallyBox {
    width: 100%;
    padding-bottom: 50px;


    .fs-20 {
      margin: 0 0 24px;
      font-weight: 500;
      line-height: 1.1;
      color: #000;
    }

    .d-flex {
      width: 100%;
      flex-wrap: wrap;
      display: flex;
      align-items: flex-start;

      > div:not([class]) {
        width: 100%;
      }

      .item {
        width: 100%;
      }
    }

    .item {
      margin-bottom: 20px;

      &.added {
        .addWrap {
          background: #f8f8f8;
          border-bottom: none;
          border-right: none;
          border-top: none;

          &:before {
            width: 8px;
            height: 100%;
            background-color: #c2e900;
            position: absolute;
            left: 0;
            top: 0;
            content: '';

            border-top-left-radius: 16px;
            border-bottom-left-radius: 16px;
          }

          .btn-green {
            display: none;
          }

          .inputSpinner {
            display: flex;
          }

          .btn-link.remove {
            display: block;
            align-self: center;
          }
        }
      }
    }

    .addWrap {
      width: 100%;
      align-items: flex-start;
      display: flex;
      flex-wrap: wrap;
      background: #ffffff;
      border: 1px solid #e3e3e3;
      box-sizing: border-box;
      border-radius: 16px;
      padding: 20px 16px 16px 24px;
      position: relative;

      &.shown {
        .btn-link.light {
          svg {
            transform: rotate(180deg);
          }
        }

        .hiddenText {
          display: block;
        }
      }

      .img-wrap {
        width: 74px;
        height: 74px;
        position: relative;

        img {
          mix-blend-mode: darken;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          object-fit: contain;
          z-index: 1;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .text-wrap {
        width: calc(100% - 74px);
        padding-left: 35px;
        align-items: flex-start;
        display: flex;
        flex-wrap: wrap;
      }

      .title {
        font-weight: 500;
        font-size: 17px;
        line-height: 17px;
        color: #000000;
        margin: 0 0 8px;
        width: 70%;

        .text {
          display: block;
          font-size: 12px;
          line-height: 17px;
          margin-top: 8px;
          font-weight: normal;
        }
      }

      .price {
        font-weight: bold;
        font-size: 17px;
        line-height: 25px;
        color: #000000;
        margin: 0 0 12px;
        width: 30%;
        text-align: right;

        .from {
          display: block;
          font-size: 12px;
          line-height: 17px;
          font-weight: normal;
          margin-bottom: 6px;
        }
      }

      .btn-link.light {
        font-weight: normal;
        align-self: center;
        margin-right: auto;
      }

      .btn-green {
        height: 40px;
        border-radius: 7px;
        width: 90px;
        margin-left: auto;
      }

      .inputSpinner {
        display: none;
        margin-left: auto;
      }

      .btn-link.remove {
        display: none;
        margin-left: 40px;
        color: #474747 !important;
        @media (min-width: 768px) {
          height: 40px;
        }
      }

      .hiddenText {
        font-size: 12px;
        line-height: 20px;
        color: #474747;
        padding: 28px 0 8px;
        display: none;
        width: 100%;

        p {
          display: block;
          margin: 0 0 8px;
        }

        .link {
          color: inherit;
          font-size: inherit;
          line-height: inherit;
        }
      }

      .buyMore {
        position: absolute;
        background: #fff;
        z-index: 5;
        width: 200px;
        padding: 15px 22px;
        border-radius: 6px;
        border: 1px solid #e3e3e3;
        font-size: 14px;
        line-height: 19px;
        color: #000;
        margin: auto;
        display: none;
        right: 110px;
        top: -30px;

        a {
          text-decoration: none;
          font-weight: bold;
          color: #000;
        }

        &.active {
          display: block;
        }
      }
    }

    .btn-outline {
      width: 100%;
      height: 42px;
      margin: -10px 0 20px;
    }
  }

  .delivery-text {
    padding: 20px 0 0;

    .fs-14 {
      margin: 16px 0;
      color: #000;
      line-height: 1.2;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .deliveryOptions {
    padding: 50px 0;

    .fs-20 {
      margin: 0 0 24px;
      font-weight: 500;
      line-height: 1.1;
      color: #000;
    }

    .d-flex {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
    }

    .item {
      cursor: pointer;
      width: 100%;
      background: #ffffff;
      border: 1px solid #e3e3e3;
      box-sizing: border-box;
      border-radius: 16px;
      padding: 24px 20px;
      display: flex;
      align-items: flex-start;
      margin: 0 0 20px;
      position: relative;
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }

      &.active {
        background: #f8f8f8;
        border: 1px solid #f8f8f8;

        &:before {
          width: 8px;
          height: 100%;
          background-color: #c2e900;
          position: absolute;
          left: 0;
          top: 0;
          content: '';
        }
      }

      &.open {
        .btn-link.light svg {
          transform: rotate(180deg);
        }
      }

      .img-wrap {
        width: 64px;
        height: 64px;
        position: relative;

        img {
          mix-blend-mode: darken;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          object-fit: contain;
          z-index: 1;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .text-wrap {
        width: calc(100% - 64px);
        padding-left: 24px;
      }

      .title {
        color: #000;
        font-weight: 500;
        font-size: 17px;
        line-height: 17px;
        margin: 0 0 8px;
      }

      .text {
        margin: 0 0 16px;

        &:last-child {
          margin-bottom: 0;
        }

        p {
          margin: 0;
          display: block;
          font-size: 12px;
          line-height: 18px;
        }
      }

      .btn-link.light {
        font-weight: normal;

        &.open {
          margin-bottom: 32px;

          svg {
            transform: rotate(180deg);
          }

          @media (max-width: 767px) {
            margin-bottom: 24px;
          }
        }
      }

      .hiddenText {
        padding: 32px 0 0;

        strong {
          display: block;
          margin-bottom: 6px;
        }
      }
    }
  }

  .resultBox {
    padding-top: 50px;
    width: 100%;

    .fs-17 {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      font-weight: bold;
      font-size: 17px;
      line-height: 25px;
      color: #000000;
      margin: 0 0 40px;
    }

    .fs-12 {
      color: #474747;
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
      margin: -20px 0 0;
    }
  }

  @media (max-width: 1300px) {
    padding-top: 32px;
    .abs-wrap {
      //width: calc(100% - 300px);
    }
    .yourBag__price {
      font-size: 20px;
    }
    .yourBag__name {
      font-size: 20px;
      //width: 300px;
      //max-width: 300px;
    }
    .grid {
      grid-gap: 32px;
    }
  }
  @media (max-width: 991px) {
    padding-top: 32px;

    .titleYb.grid {
      margin-bottom: 36px;

      .col.x-5 {
        display: none;
      }

      .backBtn {
        display: none;
      }

      .fs-36 {
        font-size: 20px;
      }
    }
    .grid {
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 36px;

      .col.x-5 {
        grid-column: span 1;
      }

      .col.x-7 {
        grid-column: span 1;
      }

      &:last-child {
        border-bottom: 1px solid #e3e3e3;
        padding-bottom: 98px;
        margin-bottom: 76px;
      }
    }
    .sticky-wrap {
      max-width: 610px;
      margin: 0 auto;
    }
    .carousel-nav {
      .carousel-cell {
        width: 64px;
        height: 64px;
      }
    }
    .yourBag__name {
      font-size: 17px;
      line-height: 25px;
      //margin: 0 calc(100% - 346px) 8px 0;
    }
    .yourBag__text {
      font-size: 12px;
      line-height: 22px;
      margin: 0 calc(100% - 346px) 24px 0;
    }
    .yourBag__price {
      font-size: 17px;
      line-height: 25px;

      span {
        font-size: 10px;
      }
    }
    .yourBag__list {
      &.open {
        li {
          display: block !important;
        }
      }

      li {
        font-size: 12px;

        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6) {
          display: block;
        }

        &:nth-child(7),
        &:nth-child(8),
        &:nth-child(9),
        &:nth-child(10) {
          display: none;
        }
      }
    }

    hr {
      margin: 36px 0;
    }

    .includedDelivery {
      .fs-20 {
        font-size: 17px;
        line-height: 17px;
      }
    }
    .additionallyBox {
      padding-bottom: 40px;

      .fs-20 {
        font-size: 17px;
        line-height: 17px;
      }
    }
    .delivery-text {
      padding: 16px 0 0;
    }
    .deliveryOptions {
      padding: 40px 0;

      .fs-20 {
        font-size: 17px;
        line-height: 17px;
      }
    }
    .resultBox {
      padding-top: 40px;

      .fs-17 {
        font-size: 14px;
        line-height: 15px;
      }
    }
  }
  @media (max-width: 767px) {
    .titleYb.grid {
      margin-bottom: 24px;
    }

    .grid {
      grid-gap: 28px 0;
      padding-bottom: 48px;
      margin-bottom: 48px;

      &:last-child {
        border-bottom: none;
        padding-bottom: 140px;
        margin-bottom: 0;
      }
    }
    .sticky-wrap {
      position: relative;
      top: 0;
    }

    .yourBag__name {
      margin: 0 0 16px;
      width: 100%;
      max-width: 100%;
    }
    .select-primary-wrap {
      margin: 0 auto 20px 0;
    }
    .select-primary {
      align-self: flex-end;
    }
    .yourBag__price {
      line-height: 1.2;
    }
    .abs-wrap {
      position: relative;
      max-width: calc(100% - 70px - 16px);
      padding-left: 0;
      align-items: flex-start;
      margin-bottom: 20px;

      .btn-link {
        margin-top: 8px;
        font-size: 12px;
        line-height: 12px;
      }
    }
    .yourBag__text {
      width: 100%;
      max-width: 100%;
      margin: 0 0 16px;
      line-height: 18px;
    }
    .yourBag__list {
      margin: 0 0 8px;

      &.open {
        li {
          display: block !important;
        }
      }

      li {
        margin-bottom: 10px;

        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          display: block;
        }

        &:nth-child(6),
        &:nth-child(7),
        &:nth-child(8),
        &:nth-child(9),
        &:nth-child(10) {
          display: none;
        }
      }
    }
    hr {
      margin: 48px 0;
    }
    .includedDelivery {
      .fs-20 {
        font-size: 20px;
        line-height: 21px;
      }

      .flex-wrapper {
        grid-gap: 24px 20px;
      }
    }
    .additionallyBox {
      padding-bottom: 0;

      .fs-20 {
        font-size: 20px;
        line-height: 21px;
      }

      .addWrap {
        padding: 16px;

        .img-wrap {
          width: 64px;
          height: 64px;
        }

        .text-wrap {
          width: calc(100% - 64px);
          padding-left: 16px;
          padding-top: 10px;

          .title {
            font-size: 14px;
            width: 100%;
            padding-right: 60px;
            order: 1;

            .text {
              margin-top: 4px;
              display: none;
            }
          }

          .btn-link.light {
            order: 2;
            font-size: 12px;
            width: 100%;
            margin-bottom: 20px;

            .arr {
              margin: 0 0 0 8px;
            }
          }

          .price {
            font-size: 14px;
            line-height: 1.1;
            text-align: left;
            order: 3;
            margin: 0;
            width: calc(100% - 92px);
            align-self: center;
          }

          .inputSpinner {
            order: 4;
          }

          .hiddenText {
            padding: 24px 0 0;
            order: 5;
            width: calc(100% + 80px);
            margin-left: -80px;
          }

          .btn-green {
            order: 4;
          }
        }

        .btn-link.remove {
          position: absolute;
          top: 26px;
          right: 16px;
          font-size: 12px;
          line-height: 12px;
          color: rgba(0, 0, 0, 0.3) !important;
        }
      }

      .item {
        margin-bottom: 16px;
      }
    }

    .deliveryOptions {
      padding: 0;

      .fs-20 {
        font-size: 20px;
        line-height: 21px;
      }

      .item {
        .title {
          font-size: 14px;
          margin: 0 0 8px;
        }

        .hiddenText {
          padding: 24px 0 0;
        }
      }
    }
    .resultBox {
      padding-top: 0;

      .fs-17 {
        margin: 0 0 24px;
      }

      .fs-12 {
        margin: 0;
      }
    }
  }
  @media (max-width: 575px) {
    .includedDelivery {
      .flex-wrapper {
        align-items: flex-start;
        grid-gap: 20px;

        .item {
          flex-wrap: wrap;
          background: #f8f8f8;
          height: 100%;
          flex-direction: column;
          justify-content: center;
          padding: 4px 0;
          border-radius: 6px;

          .img-wrap {
            width: 100%;
            padding-top: 60%;
            height: 0;
            margin-bottom: 0;

            img {
              width: 80%;
              height: 100%;
            }
          }

          .text {
            width: 100%;
            margin: 0;
            padding: 12px;
            text-align: center;

            .btn-link {
              margin-left: auto;
              margin-right: auto;
              justify-content: center;
            }
          }
        }
      }
    }
  }
  @media (max-width: 350px) {
    .additionallyBox {
      .item.added .addWrap:before {
        width: 6px;
      }

      .addWrap {
        padding: 10px;

        .img-wrap {
          width: 48px;
          height: 48px;
        }

        .text-wrap {
          width: calc(100% - 48px);
          padding-left: 8px;
        }

        .text-wrap .hiddenText {
          padding: 16px 0 8px;
          order: 5;
          width: calc(100% + 54px);
          margin-left: -54px;
        }
      }
    }
  }
}

.emptyBag {
  .d-flex {
    padding: 65px 0 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    max-width: 368px;
    margin: auto;

    .fs-24 {
      margin: 0 0 30px;
      white-space: nowrap;
    }

    img {
      margin-bottom: 98px;
    }

    .btn {
      width: 100%;
    }
  }

  @media (max-width: 767px) {
    .d-flex {
      padding: 124px 0 65px;

      .fs-24 {
        margin: 0 0 20px;
        font-size: 20px;
      }

      img {
        margin-bottom: 130px;
      }

      .btn {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.resultFixLine {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 2000;
  border-top: 1px solid #e3e3e3;
  padding: 5px 0;

  .grid {
    display: grid;
    grid-gap: 64px;
    width: 100%;
    grid-template-columns: repeat(12, 1fr);

    .col {
      &.x-5 {
        grid-column: span 5;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .text-wrap {
          @media (min-width: 992px) {
            width: calc(50% - 8px);
          }

        }
      }

      &.x-7 {
        grid-column: span 7;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }

  .text-wrap {
    display: flex;
    align-items: center;
    max-width: 190px;
    margin-right: 16px;

    img {
      width: 26px;
      min-width: 26px;
      height: 26px;
      margin-right: 12px;
    }

    .fs-14 {
      line-height: 17px;
      color: #474747;
      margin: 0;

      strong {
        display: block;
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }

  .totalText {
    margin: 0 16px 0 0;
    text-align: left;

    .fs-20 {
      line-height: 1;
      display: block;
      margin: 0 0 6px;
      font-weight: bold;
      color: #000000;
      max-width: 250px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .fs-10 {
      margin: 0;
      font-size: 10px;
      line-height: 15px;
      color: #000000;
      max-width: 230px;
    }
  }

  .btn.btn-green {
    border-radius: 7px;
    width: 368px;
    cursor: pointer;

    &[disabled] {
      cursor: default;
    }
  }

  @media (max-width: 1300px) {
    .grid {
      grid-gap: 32px;
    }
  }
  @media (max-width: 991px) {
  }
  @media (max-width: 991px) {
    padding: 12px 0;
    .text-wrap {
      display: none;
    }
    .totalText {
      margin-right: 0;
      width: 100%;
      position: relative;
      padding-right: 170px;

      .fs-20 {
        font-size: 12px;
        line-height: 12px;
        max-width: 100%;
        margin-bottom: 10px;
        font-weight: normal;

        span {
          font-weight: bold;
          display: block;
          font-size: 17px;
          line-height: 25px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-top: 4px;
        }
      }

      .fs-10 {
        font-size: 12px;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.3);
        min-width: calc(100% + 170px);
      }
    }
    .btn.btn-green {
      width: 374px;
      position: absolute;
      right: 24px;
      top: 10px;
    }
    .grid {
      grid-template-columns: repeat(1, 1fr);
      display: block;

      .col {
        flex-wrap: wrap;

        &.x-5 {
          display: none;
        }

        &.x-7 {
          grid-column: span 1;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .btn.btn-green {
      width: 157px;
    }
  }
  @media (max-width: 350px) {
    .btn.btn-green {
      width: 130px;
      padding-left: 8px;
      padding-right: 8px;
    }
    .totalText {
      padding-right: 140px;
    }
  }
}
</style>
